import { ITaskItem } from "./shared";

export interface ILeaveProjectRequest {
    UserPrincipalName: string;
}

export interface ILeaveProjectResponse {
    ProjectSlug: string;
    Id: string;
    DateCreatedUtc: Date;
    UserPrincipalName: string;
    BoardId: string;
    Status: string; // TODO: Change it to enum types. Find statuses from the state machine doc
    StatusDateTimeUtc: Date;
    ApprovedDateTimeUtc: Date;
    TaskItems: ITaskItem[];
}

export enum CreateLeaveProjectDomainValidationFailureReasonEnum {
    Indeterminate = "Indeterminate",
    ProjectNotFound = "ProjectNotFound",
    NotAMemberOfProject = "NotAMemberOfProject",
    AuthenticatedUserDoesNotHavePermission = "AuthenticatedUserDoesNotHavePermission",
    UserBelongsToSingleProject = "UserBelongsToSingleProject",
    InFlightManagedProcesses = "InFlightManagedProcesses",
    ProjectAdminCannotRemoveThemselfFromProject = "ProjectAdminCannotRemoveThemselfFromProject",
}

export interface ILeaveProjectErrorResponse {
    ValidationFailureReason: CreateLeaveProjectDomainValidationFailureReasonEnum;
}
